import React from 'react';
import PropTypes from 'prop-types';
import { Building2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../../components/ui/card';
import { Checkbox } from '../../../../../components/ui/checkbox';
import { ScrollArea } from '../../../../../components/ui/scroll-area';

function DepartmentFilter({ departments, selectedDepartments, onFilterChange }) {
  return (
    <Card className="w-64 shrink-0 h-fit sticky top-6">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          Filter by Department
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <ScrollArea className="h-[400px] pr-4">
          <div className="space-y-3">
            {departments.length === 0 ? (
              <p className="text-sm text-muted-foreground">No departments available</p>
            ) : (
              departments.map((department) => {
                const isSelected = selectedDepartments.includes(department._id);
                const checkboxId = `department-${department._id}`;
                return (
                  <label
                    key={department._id}
                    htmlFor={checkboxId}
                    className="flex items-center gap-3 cursor-pointer group"
                  >
                    <Checkbox
                      id={checkboxId}
                      checked={isSelected}
                      onCheckedChange={() => onFilterChange(department._id)}
                    />
                    <span className="text-sm group-hover:text-foreground transition-colors">
                      {department.title}
                    </span>
                  </label>
                );
              })
            )}
          </div>
        </ScrollArea>

        {selectedDepartments.length > 0 && (
          <div className="mt-4 pt-4 border-t border-border">
            <p className="text-xs text-muted-foreground">
              {selectedDepartments.length} department{selectedDepartments.length !== 1 ? 's' : ''}{' '}
              selected
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

DepartmentFilter.propTypes = {
  departments: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedDepartments: PropTypes.arrayOf(PropTypes.string).isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

export default DepartmentFilter;
